/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Mini_S3Inputs */

const en_tut_mini_s3 = /** @type {(inputs: Tut_Mini_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From Mini you can change **Status saya**, search for people, and press **Kembali ke jendela kantor**.`)
};

const id_tut_mini_s3 = /** @type {(inputs: Tut_Mini_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari Mini Anda bisa mengganti **Status saya**, mencari rekan, dan menekan **Kembali ke jendela kantor**.`)
};

/**
* | output |
* | --- |
* | "From Mini you can change **Status saya**, search for people, and press **Kembali ke jendela kantor**." |
*
* @param {Tut_Mini_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_mini_s3 = /** @type {((inputs?: Tut_Mini_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Mini_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_mini_s3(inputs)
	return en_tut_mini_s3(inputs)
});